import languages from './Translations';

let currentLanguage = 'jp';
const isRunningInDocker = process.env.REACT_APP_RUNNING_IN_DOCKER === 'true';
console.log(process.env.REACT_APP_RUNNING_IN_DOCKER);
console.log(process.env.REACT_APP_RUNNING_IN_DOCKER === 'true');
const backendProtocol = process.env.REACT_APP_BACKEND_PROTOCOL || 'http';
const backendHost = process.env.REACT_APP_BACKEND_HOST || '10.133.91.202';
const backendPort = process.env.REACT_APP_BACKEND_PORT || '8111';
//  const developmentDomain = "http://10.133.91.202:8113/";
const developmentDomain = `${backendProtocol}://${backendHost}:${backendPort}/`;
const dockerDomain = "http://0.0.0.0:8111/";
const domain = isRunningInDocker ? dockerDomain : developmentDomain;
console.log(domain);
const config = {
  local: {
    PATIENT_LOGIN: 'http://localhost:5000/api/auth/api/login',
    AP_LOGIN: 'http://localhost:5000/api/auth/api/loginap',
    EP_LOGIN: 'http://localhost:5000/api/auth/api/loginep',
    START_AI_LIST: 'http://localhost:5000/api/auth/api/startai',
    START_AI_SAVE: "http://localhost:5000/api/auth/api/startai",
    CHIEF_COMPLAINT_GET: "http://localhost:5000/api/auth/api/cc",
    CHIEF_COMPLAINT_SAVE: "http://localhost:5000/api/auth/api/cc",
    GET_AICHAT: "http://localhost:5000/api/auth/doctor/ai_dialog",
    AICHAT_SAVE: "http://localhost:5000/api/auth/api/patientai",
    AICHAT_QUESTION: "http://localhost:5000/api/questions",
    AICHAT_PERSONALIZE: "http://localhost:5000/api/personalize",
    GET_PATIENTS: "http://localhost:5000/api/auth/api/appatients/",
    SAVE_PATIENTS_INTERVIEW: "http://localhost:5000/api/auth/patient/save_patient_interview",
    REGISTRATION: "http://localhost:5000/api/auth/api/register",
    GET_MEDICAL_LOG: "http://localhost:5000/api/auth/doctor/medical_log/",
    GET_ATTENDING_DOCTOR: "http://localhost:5000/api/auth/api/attending",
    languages: languages[currentLanguage],
  },
  development: {
    PATIENT_LOGIN: domain + 'api/v1/patient/login',
    AP_LOGIN: domain + 'api/v1/doctor/login',
    EP_LOGIN: domain + 'api/v1/doctor/exp_login',
    START_AI_LIST: domain + 'api/v1/doctor/patient_info',
    START_AI_GET: domain + "api/v1/patient/recent_status",
    START_AI_SAVE: domain + "api/v1/patient/recent_status",
    GET_AICHAT: domain + "api/v1/doctor/ai_dialog",
    CHIEF_COMPLAINT_GET: domain + "api/v1/patient/chief_complaint",
    CHIEF_COMPLAINT_SAVE: domain + "api/v1/patient/chief_complaint",
    AICHAT_SAVE: domain + "api/v1/patient/save_patient_interview",
    AICHAT_QUESTION: domain + "api/v1/questions/select",
    AICHAT_PERSONALIZE: domain + "api/v1/questions/personalize",
    GET_PATIENTS: domain + "api/v1/doctor/patients/",
    SAVE_PATIENTS_INTERVIEW: domain + "api/v1/patient/save_patient_interview ",
    REGISTRATION: domain + "api/v1/doctor/new_registration",
    GET_SYMPTOM_LOG: domain + "api/v1/patient/symptom_log",
    GET_MEDICAL_LOG: domain + "api/v1/doctor/medical_log",
    POST_CONSULTATION: domain + "api/v1/doctor/register_medical_info",
    GET_DOCTOR_COMMENT: domain + "api/v1/doctor/doctor_comment",
    GET_PATIENT_DOCTOR_COMMENT: domain + "api/v1/patient/doctor_comment",
    GET_ATTENDING_DOCTOR: domain + "api/v1/doctor/attending_doctors",
    languages: languages[currentLanguage],
  },
};
const currentEnvironment = 'development';
//  const currentEnvironment ='local' ;

// Function to switch language at runtime
export const setLanguage = (language) => {
  if (config[currentEnvironment].languages[currentLanguage]) {
    currentLanguage = currentLanguage;
  }
};

const appConfig = {
  ...config[currentEnvironment],
  language: () => config[currentEnvironment].languages[currentLanguage],
};

export default appConfig;


